/* Importing the React library and the useCallback, useState, and useEffect hooks. */
import { useCallback, useContext, useState, useEffect } from 'react';

/* Importing the useDispatch hook from the react-redux library. */
import { useDispatch } from 'react-redux';

/* Importing from the react-router-dom package. */
import { useNavigate, useParams } from 'react-router-dom';

/* Importing the components from the material-ui library. */
import { Container, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

/* Importing the sweetalert2 library. */
import Swal from 'sweetalert2';

/* Importing the functions from the Redux slices. */
import { fDevice } from '../../utils/Device/Device.utils.format';
import { getDevice } from '../../features/device/deviceSlice';

/* Importing the Page component from the components folder. */
import Page from '../../components/Page';
import Telemetry from '../../components/Telemetry';

import { ColorModeContext } from '../../theme/index';

const ContentStyle = styled('div')(({ theme }) => ({
  // maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));
/**
 * The MonitorDashboard component is used to register a device with the server.
 * It is used to register a device with the server.
 * @returns None
 */
export default function MonitorDashboard() {
  /* Using the useParams hook to get the params from the URL. */
  const params = useParams();

  /* Importing the useDispatch hook from the react-redux library. */
  const dispatch = useDispatch();

  /* Using the useNavigate hook to navigate to a different page. */
  const navigate = useNavigate();

  const colorMode = useContext(ColorModeContext);

  const [Device, setDevice] = useState({
    notification: false,
    notificationSound: 'default',
    maxslot: 8,
  });

  /**
   * Initializes the data for the page.
   */
  const initializeData = useCallback(async () => {
    let hasDevice = false;
    if (params.id) {
      const resultAction = await dispatch(getDevice(params.id));
      if (getDevice.fulfilled.match(resultAction)) {
        const data = resultAction.payload;
        if (data) {
          hasDevice = true;
          const deviceObj = fDevice(data);
          setDevice(deviceObj);
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: resultAction.payload,
          showConfirmButton: true,
        });
        console.log(resultAction.payload);
      }
    }
    if (!hasDevice) {
      Swal.fire({
        icon: 'error',
        title: 'No Device record found',
        showConfirmButton: true,
      }).then((result) => {
        if (result.value) {
          navigate(`/monitoring/list`, { replace: false });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, navigate, params.id]);

  /* Calling the initializeData function when the component mounts. */
  useEffect(() => {
    colorMode.setColorMode('dark');
    initializeData();
  }, [colorMode, initializeData]);

  return (
    <Page title={Device.deviceName_name}>
      <Container maxWidth="false">
        <ContentStyle>
          <Grid container spacing={2} direction="row" justifyContent="flex-start" alignItems="flex-start">
            <Telemetry Device={Device} columnSize={{ xs: 12, sm: 6, lg: 6, xl: 4 }} />
          </Grid>
        </ContentStyle>
      </Container>
    </Page>
  );
}
